module.exports = __webpack_public_path__ + "static/slidecard01_03-7d5e6da65fa723a43f74099ecf3fc92c.png";